import { DISALLOWED_BULKUPLOAD_COLUMNS } from './constants';
/**
 * The array of validations to perform.
 * Each validation is of the following shape:
 * {
 *  name: "name of the validation",
 *  failed: (data, file) => {
 *      // @param data : contains the string content of the CSV
 *      // @param file : name of the CSV file
 *      // @returns false if validations succeeded or a string describing the validation error.
 *  }
 * }
 */

const extractColumnsFromCsv = (csv) => {
    const arr = csv.split(/\r\n|\n/);
    const headers = arr[0].split(',').map((each) => each.trim().replace(/^["|'](.*)["|']$/, '$1'));
    return headers;
};

const Validations = [
    {
        name: 'Validation on allowed CSV columns',
        failed: (data, file) => {
            const csvColumns = extractColumnsFromCsv(data);

            for (const actualColumns of csvColumns) {
                if (actualColumns in DISALLOWED_BULKUPLOAD_COLUMNS) {
                    return `The column '${actualColumns}' is not allowed \n 
                        to be present in the CSV (${file.name}).\n Please remove the column and reupload!`;
                }
            }

            return false;
        },
    },
];

const _readAsync = async (file) => {
    return new Promise((resolve, reject) => {
        let reader = new FileReader();
        reader.readAsText(file);

        reader.onload = function () {
            resolve(reader.result);
        };

        reader.onerror = function (error) {
            reject(error);
        };
    });
};
/**
 *
 * @param {*} files An array of CSV files to perform the validations on.
 * @param {*} onSuccessfull The callback to execute if all validations succeeded.
 * @param {*} onFailed The callback to execute if any validations failed.
 */

export const performDefaultValidations = async (files, onSuccessfull, onFailed) => {
    const status = {
        failed: false,
        message: null,
        file: null,
        validated: files.length,
    };

    for (const file of files) {
        for (const eachValidation of Validations) {
            const validatonFailed = eachValidation.failed(await _readAsync(file), file);

            if (validatonFailed) {
                status.failed = true;
                status.file = file;
                status.message = validatonFailed;
                break;
            }
        }

        status.validated -= 1;

        if (status.failed) {
            return onFailed(status.message, status.file.name);
        }

        if (status.validated == 0 && !status.failed) {
            return onSuccessfull();
        }
    }
};
